//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('acCustTransesAge', {
//        templateUrl: 'views/components/views/acCustTransesAge/acCustTransesAge.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'acCustTransesAgeService', 'logisticService', 'ttGridFactory', 'rememberService', function (stateService, utilityService, acCustTransesAgeService, logisticService, ttGridFactory, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                businessco_no: ''
//            };

//            vm.model = {
//                gridReady: false,
//                setting: {},
//                selectListCompanies: []
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_accusttransesage_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({ wrapping: true });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await acCustTransesAgeService.getAcCustTransesAge())[0];
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 2797,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    switch (key) {
//                        case 'businessco_no':
//                            variableNames[key] = 'w_accountingprocessing' + '.' + key;
//                            break;
//                        default:
//                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                            break;
//                    }
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                        vm.model.setting.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no, true) !== true) return;

//                        Promise.all([
//                            rememberFunc('businessco_no')
//                        ]).then(() => {
//                            loadGrid();
//                            Promise.resolve();
//                        });
//                        break;
//                    case 'date_tom':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.date_tom) !== true) return;

//                        vm.model.setting.date_tom = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.date_tom) !== true) return;

//                        loadGrid();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();

//                return Promise.all([
//                    loadCompanies()
//                ]).then(() => {
//                    loadGrid();
//                    Promise.resolve();
//                });
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
